import React from 'react';
import { isMobile } from 'common/helpers';
import { OfficialHotel as S } from './styles';

const content = {
  web: {
    header: {
      title: 'Official SWC Hotel',
      desc: 'SWC attendees get exclusive discounts at the official hotel. Stay at the conference venue and <br />be even closer to speakers, CEOs and elite Amazon Sellers.',
    },
  },
  mobile: {
    header: {
      title: 'Official SWC Hotel',
      desc: 'Attendees get exclusive discounts at the official hotel.',
    },
  },
};

class Header extends React.PureComponent {
  render() {
    const header = (isMobile() ? content.mobile.header : content.web.header);
    return (
      <S.Header>
        <h1>{header.title}</h1>
        <h4 dangerouslySetInnerHTML={{ __html: header.desc }} />
      </S.Header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/containers/Hotel/Header.js